export default {
  performance: {
    title: 'Your Performance',
    cards: {
      customers: {
        label: 'Total customers',
        description:
          'Check back here to review insights about your customers and their activities.',
        linkLabel: 'See customer activity'
      },
      purchasedCoins: {
        label: 'Purchased Coins',
        description:
          'Enable customers to buy Coins from your business and watch transactions grow',
        linkLabel: 'Sell your Coins'
      },
      rewardedCoins: {
        label: 'Rewarded Coins',
        description:
          'Track your customers spending activity, rewards balance and store visits.',
        linkLabel: 'See activity'
      },
      totalTransactions: {
        label: 'Total transactions',
        description:
          'Gain deeper insights into how much your most loyal customers are spending and when.',
        linkLabel: 'See reports'
      },
      redemptions: {
        label: 'Offer Redemptions',
        tooltipText: 'Total number of offers successfully redeemed by members.'
      },
      savedOffers: {
        label: 'Offers Saved',
        tooltipText:
          'Total number of offers that have been saved by members, available for future use.'
      },
      nonMemberReached: {
        label: 'Non-members Reached',
        tooltipText:
          'Total number of Twism app users, who are not yet members of your program, exposed to your brand while navigating the ecosystem.'
      },
      businessImpressions: {
        label: 'Business Impressions',
        tooltipText:
          'Total number of times your business was displayed to members within Twism. <a href="https://support.twism.com/hc/en-us/articles/29210657024525-What-are-Business-Impressions" target="_blank">Learn more.</a>'
      },
      coinsInCirculation: {
        label: 'Coins in Circulation',
        tooltipText: `Total number of Coins currently held in the wallets of your members.`
      },
      redeemedCoins: {
        label: 'Coins Redeemed',
        tooltipText: `Number of Coins that have been redeemed by your members.`
      },
      membersRedeemedCoins: {
        label: 'Members Redeeming Coins',
        tooltipText: `Total number of members who have redeemed Coins from your business.`
      },
      loyaltyMembers: {
        label: 'New Members',
        tooltipText: `Total number of members who have become members of your loyalty program.`
      },
      paymentCodeConversionRatio: {
        label: 'Payment Code Conversion Ratio',
        tooltipText: `Percentage of payment codes held by members that have been redeemed.`
      },
      paymentRelatedToRedemptions: {
        label: 'Payments Related to Redemptions',
        tooltipText: `Estimated financial value generated when members use their Coins or redeem offers.`
      },
      coinsMinted: {
        label: 'Coins Minted',
        tooltipText: `Total number of Coins minted from your Twism campaigns.`
      },
      totalFavorites: {
        label: 'Total Favorites',
        tooltipText:
          'Members who have "favorited" your business in their Twism app to provide them with quick access to your features. These members LOVE your business! <a href="https://support.twism.com/hc/en-us/articles/31788934425741-What-are-Favorites" target="_blank">Learn more.</a>.'
      }
    }
  },
  startGuide: {
    carousel: {
      tipOnCloseTask: {
        sellcoins: 'You can activate the Sell Coins later in this tab.',
        rewardcoins: 'You can set up your Loyalty Program later in this tab',
        welcomecoins: 'You can create Welcome Coins later in this tab.',
        specialcoins: 'You can create Offers later in this tab.',
        referralprogram:
          'You can activate the Referral Program later in this tab.',
        socialrewards: 'You can activate the Social Rewards later in this tab.',
        invitecustomers: 'You can Invite Customers later in this tab.'
      }
    }
  },
  activePrograms: {
    title: 'Active programs',
    program: {
      noDeadLineLabel: 'No deadline',
      endLabel: 'Ends: ',
      socialrewards: {
        title: 'Social Rewards'
      },
      sellcoins: {
        title: 'Sell Coins'
      },
      specialcoins: {
        title: 'Offers'
      },
      welcomecoins: {
        title: 'Welcome Coins'
      },
      invitecustomers: {
        title: 'Invite Customers'
      },
      referralprogram: {
        title: 'Referral Program'
      },
      rewardcoins: {
        title: 'Loyalty Program'
      }
    }
  },
  discoverMore: {
    title: 'Discover more'
  },
  needHelp: {
    title: 'Need help?',
    titleList: 'Here are some articles that can help you get started',
    titleListEmpty:
      'Visit our help center to find more information about Twism or contact us if you want to ask about a topic.',
    cta: 'Visit our help center',
    contact: 'Contact support'
  },
  startGuideSideContent: {
    coinSection: {
      labelCustomizeButton: 'Customize Coin',
      messageDismissible: {
        title: 'Tip',
        description: 'A good Coin image will get you ahead of competition.'
      }
    },
    featuresSection: {
      title: 'My Tools',
      description: 'Build a customized marketing solution in minutes.',
      cta: 'Explore all tools'
    }
  }
};
